<template>
  <action-log-template :actionLog="actionLog">
    <template #actionName>
      <p :class="['action-type flex-row flex__left inline-flex']">
        <i
          :class="['font-size__small', 'fal fa-check-circle', 'color__blue']"
        ></i>
        <span class="font-size__small no_wrap color__blue">
          &nbsp;{{ actionNameLabel || "-" }}
        </span>
      </p>

      <value-change-logs-detail
        :valueChangeLogs="valueChangeLogs"
      ></value-change-logs-detail>
    </template>
  </action-log-template>
</template>

<script>
  import vbUtils from "../../services/doc/vbUtils";
  import h from "../../services/h";
  import hanhChinhUtils from "../../services/hanhChinhUtils";
  import ActionLogTemplate from "../adminstration/ketluan/action-log-template";
  import ValueChangeLogsDetail from "../adminstration/ketluan/value-change-logs-detail";

  export default {
    name: "vb-outgoing-doc-sua-sai-action-log",
    components: {ActionLogTemplate, ValueChangeLogsDetail},
    props: ["actionLog"],
    filters: {},
    data() {
      return {
        actionNameLabel: null,
        dataJson: null,
        valueChangeLogs: [],
        vbOutgoingDoc: null,
        oldVbOutgoingDoc: null
      };
    },
    created() {
      this.actionNameLabel = vbUtils.getActionLogActionNameLabel(
        this.actionLog.actionName
      );
      this.dataJson = JSON.parse(this.actionLog.dataJson);
      this.populateValueChangeLogs();
    },
    methods: {

      formatDate(value) {
        return hanhChinhUtils.formatDate(value);
      },

      getDisplayProperty(property) {
        switch (property) {
          case "quote":
            return "Trích yếu";
          case "docTypeId":
          case "docTypeName":
            return "Loại văn bản";
          case "priorityId":
          case "priorityName":
            return "Độ khẩn";
          case "docCode":
            return "Số ký hiệu";
          case "docDate":
            return "Ngày văn bản";
          case "numberOfPage":
            return "Số trang";
          case "signerUserDeptRoleId":
          case "signerName":
            return "Người ký duyệt";
          case "deptEditorId":
          case "deptEditorName":
            return "Đơn vị thực hiện";
          case "deadlineDate":
            return "Hạn xử lý";
          case "vbAttachment":
            return "File văn bản";
          case "docRelationFiles":
            return "File đính kèm";
          default:
            return "-";
        }
      },

      populateValueChangeLog(property) {
        let oldValue = this.oldVbOutgoingDoc[property];
        let newValue = this.vbOutgoingDoc[property];
        if (oldValue !== newValue) {
          return this.valueChangeLogs.push({
            property: property,
            propertyLabel: this.getDisplayProperty(property),
            oldValue: oldValue,
            newValue: newValue
          });
        }
      },

      populateValueChangeLogs() {
        this.vbOutgoingDoc = this.dataJson.vbOutgoingDoc;
        this.oldVbOutgoingDoc = this.dataJson.oldVbOutgoingDoc;
        h.each(
          [
            "quote",
            "docTypeId",
            "priorityId",
            "docCode",
            "docDate",
            "numberOfPage",
            "signerUserDeptRoleId",
            "deptEditorId",
            "deadlineDate",
            "vbAttachment",
            "docRelationFiles"
          ],
          property => {
            switch (property) {
              case "docTypeId":
                this.populateValueChangeLog("docTypeName");
                break;
              case "priorityId":
                this.populateValueChangeLog("priorityName");
                break;
              case "signerUserDeptRoleId":
                this.populateValueChangeLog("signerName");
                break;
              case "deptEditorId":
                this.populateValueChangeLog("deptEditorName");
                break;
              case "docDate":
              case "deadlineDate":
                let oldValue = this.formatDate(this.oldVbOutgoingDoc[property]);
                let newValue = this.formatDate(this.vbOutgoingDoc[property]);
                if (oldValue !== newValue) {
                  return this.valueChangeLogs.push({
                    property: property,
                    propertyLabel: this.getDisplayProperty(property),
                    oldValue: oldValue,
                    newValue: newValue
                  });
                }
                break;
              case "vbAttachment":
                let oldVbAttachment = this.oldVbOutgoingDoc["vbAttachment"];
                let newVbAttachment = this.vbOutgoingDoc["vbAttachment"];
                if (oldVbAttachment.id !== newVbAttachment.id) {
                  return this.valueChangeLogs.push({
                    property: "vbAttachment",
                    propertyLabel: this.getDisplayProperty("vbAttachment"),
                    oldValue: oldVbAttachment.fileName,
                    newValue: newVbAttachment.fileName
                  });
                }
                break;
              case "docRelationFiles":
                let oldDocRelations = this.oldVbOutgoingDoc["docRelationFiles"];
                let newDocRelations = this.vbOutgoingDoc["docRelationFiles"];

                const oldDocRelationIds = h.collect(oldDocRelations, item => item.id);
                const newDocRelationIds = h.collect(newDocRelations, item => item.id);

                const oldDocRelationFileNames = h.collect(oldDocRelations, item => item.fileName);
                const newDocRelationFileNames = h.collect(newDocRelations, item => item.fileName);

                if (oldDocRelationIds.join(',') !== newDocRelationIds.join(',')) {
                  return this.valueChangeLogs.push({
                    property: "docRelationFiles",
                    propertyLabel: this.getDisplayProperty("docRelationFiles"),
                    oldValue: oldDocRelationFileNames.join(', ') || "-",
                    newValue: newDocRelationFileNames.join(', ') || "-"
                  });
                }
                this.populateValueChangeLog("docRelationFileNames");
                break;
              default:
                this.populateValueChangeLog(property);
                break;
            }
          }
        );
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/vb-outgoing-doc-sua-sai-action-log.vue